import { queryOptions } from '@tanstack/react-query';

import { labSettingsKeys } from '@/lib/query-keys';

import { fetchLabSettings } from '../services/lab-settings-api';

export function labSettingsQuery() {
  return queryOptions({
    queryKey: labSettingsKeys.all(),
    queryFn: fetchLabSettings,
    staleTime: Infinity,
    gcTime: Infinity,
  });
}
